module.exports = __webpack_public_path__ + "img/noData.debc2b66.svg";